import { TYPES } from 'action-types/materialMaster';
import * as msgs from '../../constants/validationMessages';

interface IAction {
    readonly type: string;
    readonly materialMasterList: IMaterialList[];
    readonly customerMasterList: any[];
    readonly errors: any[];
}
export interface IMaterialList{
    id: number
    materialNo: number
    name: string
    description: string
    defaultUoM: string
    category: string
    subcategory: string
}
export interface ICustomerList{
    id: number
    customerCode: string
    customerName: string
    transportationMode: string
    paymentTerm: string
    becode: string
    scvCode: string
    interCompanyIC: string
    isDeleted: string
}
export interface IMaterialState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly isFetchDataPendingError: string | string[];
    readonly materialMasterList: IMaterialList[];
    readonly isFetchCMDataError: boolean;
    readonly isFetchCMDataLoading: boolean;
    readonly customerMasterList: ICustomerList[];
}
export const defaultState: IMaterialState = {
    isFetchDataLoading: false,
    isFetchDataPendingError: '',
    isFetchDataError: false,
    materialMasterList: [],
    isFetchCMDataLoading: false,
    isFetchCMDataError: false,
    customerMasterList: [],
};  

export const reducer = (state: IMaterialState = defaultState, action: IAction): IMaterialState => {
    switch (action.type) {
        case TYPES.FETCH_MATERIAL_DATA.PENDING:
            return {
                ...state,
                materialMasterList: defaultState.materialMasterList,
                isFetchDataLoading: true,
                isFetchDataError: false,
                isFetchDataPendingError: ''
            };
        case TYPES.FETCH_MATERIAL_DATA.FULFILLED:
            return {
                ...state,
                materialMasterList: action.materialMasterList,
                isFetchDataLoading: false,
                isFetchDataError: false,
                isFetchDataPendingError: action.materialMasterList && action.materialMasterList.length>0?'':msgs.ExtraDocument.Pending_Error
            };
        case TYPES.FETCH_MATERIAL_DATA.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                isFetchDataPendingError: action.errors
            };
        case TYPES.FETCH_CUSTOMER_DATA.PENDING:
        case TYPES.RESET_CUSTOMER_DATA.PENDING:
            return {
                ...state,
                customerMasterList: defaultState.customerMasterList,
                isFetchCMDataLoading: true,
                isFetchCMDataError: false,
                isFetchDataPendingError: ''
            };
        case TYPES.FETCH_CUSTOMER_DATA.FULFILLED:
            return {
                ...state,
                customerMasterList: action.customerMasterList,
                isFetchCMDataLoading: false,
                isFetchCMDataError: false,
                isFetchDataPendingError: action.customerMasterList && action.customerMasterList.length>0?'':msgs.ExtraDocument.Pending_Error
            };
        case TYPES.FETCH_CUSTOMER_DATA.REJECTED:
            return {
                ...state,
                isFetchCMDataLoading: false,
                isFetchCMDataError: true,
                isFetchDataPendingError: action.errors
            };
        default:
            return state;
    }
};
